<template>
  <span
    v-tooltip="tooltip"
    class="flex justify-center items-center w-5 h-5 rounded-full bg-highlightBaseLight text-link font-sans text-xxs"
    >{{ num }}</span
  >
</template>

<script>
export default {
  name: 'LmBadge',
  props: {
    num: {
      type: Number,
      default: 0
    },
    tooltip: {
      type: String,
      default: null
    }
  }
}
</script>
